import { createElement } from "react";
import { plantelDeMatricula } from "./plantel";
import { nombrePlantelDeBD } from "./nombresPlanteles";

// Folio TPV de 6 digitos: id del plantel en BD (2 digitos) + 4 aleatorios.
export const generarFolioTPV = (idPlantelBD) => {
  const plantel = String(idPlantelBD).padStart(2, "0");
  const aleatorio = Math.floor(Math.random() * 10000).toString().padStart(4, "0");
  return `${plantel}${aleatorio}`;
};

// Filas del PDF a partir del carrito de caja (cada item trae precio y cantidad).
export const construirTablaPdf = (carrito, infoCaptura, folioTPV) =>
  carrito.map((item, i) => ({
    id: i + 1,
    concepto: item.concepto,
    clave: item.clave,
    precio: item.precio * item.cantidad,
    referencias: {
      Banorte: infoCaptura.banorte.lineaDeCaptura,
      BBVA: infoCaptura.bancomer.lineaDeCaptura,
    },
    folioTPV,
  }));

// La libreria de PDF pesa mucho: se carga solo al generar un PDF, no al abrir el sitio.
export const descargarOrdenDePago = async (datosPdf, nombreArchivo) => {
  const [{ pdf }, { default: Pdf }] = await Promise.all([
    import("@react-pdf/renderer"),
    import("../components/Pdf"),
  ]);

  // Nombre del plantel tal como esta en la BD (si quien llama no lo trae ya, como Ex-alumnos y Externos)
  let datos = datosPdf;
  if (!datosPdf.nombrePlantelOverride) {
    const nombre = await nombrePlantelDeBD(datosPdf.plantelOverride || plantelDeMatricula(datosPdf.code || ""));
    if (nombre) datos = { ...datosPdf, nombrePlantelOverride: nombre };
  }

  const blob = await pdf(createElement(Pdf, datos)).toBlob();

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = nombreArchivo;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
